import { makeStyles } from '@material-ui/core/styles'
const StylesWithMaterialUi = makeStyles((theme) => ({
  gridItem: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridItemSwitch: {
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  input: {
    fontFamily: 'Poppins',
    fontSize: '14px',
  },
  text: {
    fontWeight: 'bold',
    fontFamily: 'Comfortaa',
    fontSize: '15px',
  },
  btn: {
    fontSize: '12px',
    fontWeight: '300',
    fontFamily: 'Comfortaa',
    textTransform: 'none',
    width: '110px',
    height: 'auto',
  },
  gridItemBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))
export default StylesWithMaterialUi
